import React from 'react';
import { ShieldCheck } from 'lucide-react';

/**
 * BcaSchemeBadge — identifies the BCA/MOM levy scheme a professional
 * certificate maps to (e.g. SEC(K), CoreTrade, CET).
 *
 * This is a *classification tag*, not a status. It reuses the canonical pill
 * shape from StatusBadge with the `info` (blue) design-system tier so it reads
 * as an informational identifier rather than a success/warning/error state.
 *
 * The identification is auto-detected from the certificate name against the
 * levy reference catalog and is review-only — official BCA/MOM registration
 * remains the source of truth.
 *
 * @param {object} scheme - `{ code, label, category, matched_by, review_only }`
 *                          from the certificate serializer's `bca_scheme` field.
 */
export const BcaSchemeBadge = ({ scheme }) => {
  if (!scheme?.label) return null;

  const title =
    `Detected BCA scheme: ${scheme.label}. Auto-identified from the certificate ` +
    'name for HR review — official BCA/MOM registration remains the source of truth.';

  return (
    <span
      className="inline-flex items-center gap-1 rounded-full font-medium ring-1 ring-inset whitespace-nowrap px-2 py-0.5 text-[11px] bg-blue-50 text-blue-700 ring-blue-600/20"
      title={title}
    >
      <ShieldCheck className="w-3 h-3 flex-shrink-0" />
      {scheme.label}
    </span>
  );
};

export default BcaSchemeBadge;
